module.exports = __webpack_public_path__ + "img/tooltip.89551395.svg";